// extracted by mini-css-extract-plugin
module.exports = {"expires_desktop":"ExpiryPill_expires_desktop__dCEie","expires_mobile":"ExpiryPill_expires_mobile__z_cUf"};